import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as dom from '../../../../base/browser/dom.js';
import { createFastDomNode } from '../../../../base/browser/fastDomNode.js';
import { PartFingerprints, ViewPart } from '../../view/viewPart.js';

var Coordinate = function Coordinate(top, left) {
  _classCallCheck(this, Coordinate);

  this.top = top;
  this.left = left;
};

export var ViewContentWidgets = /*#__PURE__*/function (_ViewPart) {
  _inherits(ViewContentWidgets, _ViewPart);

  var _super = _createSuper(ViewContentWidgets);

  function ViewContentWidgets(context, viewDomNode) {
    var _this;

    _classCallCheck(this, ViewContentWidgets);

    _this = _super.call(this, context);
    _this._viewDomNode = viewDomNode;
    _this._widgets = {};
    _this.domNode = createFastDomNode(document.createElement('div'));
    PartFingerprints.write(_this.domNode, 1
    /* ContentWidgets */
    );

    _this.domNode.setClassName('contentWidgets');

    _this.domNode.setPosition('absolute');

    _this.domNode.setTop(0);

    _this.overflowingContentWidgetsDomNode = createFastDomNode(document.createElement('div'));
    PartFingerprints.write(_this.overflowingContentWidgetsDomNode, 2
    /* OverflowingContentWidgets */
    );

    _this.overflowingContentWidgetsDomNode.setClassName('overflowingContentWidgets');

    return _this;
  }

  _createClass(ViewContentWidgets, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ViewContentWidgets.prototype), "dispose", this).call(this);

      this._widgets = {};
    } // --- begin event handlers

  }, {
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var keys = Object.keys(this._widgets);

      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var widgetId = _keys[_i];

        this._widgets[widgetId].onConfigurationChanged(e);
      }

      return true;
    }
  }, {
    key: "onDecorationsChanged",
    value: function onDecorationsChanged(e) {
      // true for inline decorations that can end up relayouting text
      return true;
    }
  }, {
    key: "onFlushed",
    value: function onFlushed(e) {
      return true;
    }
  }, {
    key: "onLineMappingChanged",
    value: function onLineMappingChanged(e) {
      var keys = Object.keys(this._widgets);

      for (var _i2 = 0, _keys2 = keys; _i2 < _keys2.length; _i2++) {
        var widgetId = _keys2[_i2];

        this._widgets[widgetId].onLineMappingChanged(e);
      }

      return true;
    }
  }, {
    key: "onLinesChanged",
    value: function onLinesChanged(e) {
      return true;
    }
  }, {
    key: "onLinesDeleted",
    value: function onLinesDeleted(e) {
      return true;
    }
  }, {
    key: "onLinesInserted",
    value: function onLinesInserted(e) {
      return true;
    }
  }, {
    key: "onScrollChanged",
    value: function onScrollChanged(e) {
      return true;
    }
  }, {
    key: "onZonesChanged",
    value: function onZonesChanged(e) {
      return true;
    } // ---- end view event handlers

  }, {
    key: "addWidget",
    value: function addWidget(_widget) {
      var myWidget = new Widget(this._context, this._viewDomNode, _widget);
      this._widgets[myWidget.id] = myWidget;

      if (myWidget.allowEditorOverflow) {
        this.overflowingContentWidgetsDomNode.appendChild(myWidget.domNode);
      } else {
        this.domNode.appendChild(myWidget.domNode);
      }

      this.setShouldRender();
    }
  }, {
    key: "setWidgetPosition",
    value: function setWidgetPosition(widget, range, preference) {
      var myWidget = this._widgets[widget.getId()];

      myWidget.setPosition(range, preference);
      this.setShouldRender();
    }
  }, {
    key: "removeWidget",
    value: function removeWidget(widget) {
      var widgetId = widget.getId();

      if (this._widgets.hasOwnProperty(widgetId)) {
        var myWidget = this._widgets[widgetId];
        delete this._widgets[widgetId];
        var domNode = myWidget.domNode.domNode;
        domNode.parentNode.removeChild(domNode);
        domNode.removeAttribute('monaco-visible-content-widget');
        this.setShouldRender();
      }
    }
  }, {
    key: "shouldSuppressMouseDownOnWidget",
    value: function shouldSuppressMouseDownOnWidget(widgetId) {
      if (this._widgets.hasOwnProperty(widgetId)) {
        return this._widgets[widgetId].suppressMouseDown;
      }

      return false;
    }
  }, {
    key: "onBeforeRender",
    value: function onBeforeRender(viewportData) {
      var keys = Object.keys(this._widgets);

      for (var _i3 = 0, _keys3 = keys; _i3 < _keys3.length; _i3++) {
        var widgetId = _keys3[_i3];

        this._widgets[widgetId].onBeforeRender(viewportData);
      }
    }
  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {
      var keys = Object.keys(this._widgets);

      for (var _i4 = 0, _keys4 = keys; _i4 < _keys4.length; _i4++) {
        var widgetId = _keys4[_i4];

        this._widgets[widgetId].prepareRender(ctx);
      }
    }
  }, {
    key: "render",
    value: function render(ctx) {
      var keys = Object.keys(this._widgets);

      for (var _i5 = 0, _keys5 = keys; _i5 < _keys5.length; _i5++) {
        var widgetId = _keys5[_i5];

        this._widgets[widgetId].render(ctx);
      }
    }
  }]);

  return ViewContentWidgets;
}(ViewPart);

var Widget = /*#__PURE__*/function () {
  function Widget(context, viewDomNode, actual) {
    _classCallCheck(this, Widget);

    this._context = context;
    this._viewDomNode = viewDomNode;
    this._actual = actual;
    this.domNode = createFastDomNode(this._actual.getDomNode());
    this.id = this._actual.getId();
    this.allowEditorOverflow = this._actual.allowEditorOverflow || false;
    this.suppressMouseDown = this._actual.suppressMouseDown || false;
    var options = this._context.configuration.options;
    var layoutInfo = options.get(117
    /* layoutInfo */
    );
    this._fixedOverflowWidgets = options.get(30
    /* fixedOverflowWidgets */
    );
    this._contentWidth = layoutInfo.contentWidth;
    this._contentLeft = layoutInfo.contentLeft;
    this._lineHeight = options.get(51
    /* lineHeight */
    );
    this._range = null;
    this._viewRange = null;
    this._preference = [];
    this._cachedDomNodeClientWidth = -1;
    this._cachedDomNodeClientHeight = -1;
    this._maxWidth = this._getMaxWidth();
    this._isVisible = false;
    this._renderData = null;
    this.domNode.setPosition(this._fixedOverflowWidgets && this.allowEditorOverflow ? 'fixed' : 'absolute');
    this.domNode.setVisibility('hidden');
    this.domNode.setAttribute('widgetId', this.id);
    this.domNode.setMaxWidth(this._maxWidth);
  }

  _createClass(Widget, [{
    key: "onConfigurationChanged",
    value: function onConfigurationChanged(e) {
      var options = this._context.configuration.options;
      this._lineHeight = options.get(51
      /* lineHeight */
      );

      if (e.hasChanged(117
      /* layoutInfo */
      )) {
        var layoutInfo = options.get(117
        /* layoutInfo */
        );
        this._contentLeft = layoutInfo.contentLeft;
        this._contentWidth = layoutInfo.contentWidth;
        this._maxWidth = this._getMaxWidth();
      }
    }
  }, {
    key: "onLineMappingChanged",
    value: function onLineMappingChanged(e) {
      this._setPosition(this._range);
    }
  }, {
    key: "_setPosition",
    value: function _setPosition(range) {
      this._range = range;
      this._viewRange = null;

      if (this._range) {
        // Do not trust that widgets give a valid position
        var validModelRange = this._context.model.validateModelRange(this._range);

        if (this._context.model.coordinatesConverter.modelPositionIsVisible(validModelRange.getStartPosition()) || this._context.model.coordinatesConverter.modelPositionIsVisible(validModelRange.getEndPosition())) {
          this._viewRange = this._context.model.coordinatesConverter.convertModelRangeToViewRange(validModelRange);
        }
      }
    }
  }, {
    key: "_getMaxWidth",
    value: function _getMaxWidth() {
      return this.allowEditorOverflow ? window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth : this._contentWidth;
    }
  }, {
    key: "setPosition",
    value: function setPosition(range, preference) {
      this._setPosition(range);

      this._preference = preference;
      this._cachedDomNodeClientWidth = -1;
      this._cachedDomNodeClientHeight = -1;
    }
  }, {
    key: "_layoutBoxInViewport",
    value: function _layoutBoxInViewport(topLeft, bottomLeft, width, height, ctx) {
      // Our visible box is split horizontally by the current line => 2 boxes
      // a) the box above the line
      var aboveLineTop = topLeft.top;
      var heightAboveLine = aboveLineTop; // b) the box under the line

      var underLineTop = bottomLeft.top + this._lineHeight;
      var heightUnderLine = ctx.viewportHeight - underLineTop;
      var aboveTop = aboveLineTop - height;
      var fitsAbove = heightAboveLine >= height;
      var belowTop = underLineTop;
      var fitsBelow = heightUnderLine >= height; // And its left

      var actualAboveLeft = topLeft.left;
      var actualBelowLeft = bottomLeft.left;

      if (actualAboveLeft + width > ctx.scrollLeft + ctx.viewportWidth) {
        actualAboveLeft = ctx.scrollLeft + ctx.viewportWidth - width;
      }

      if (actualBelowLeft + width > ctx.scrollLeft + ctx.viewportWidth) {
        actualBelowLeft = ctx.scrollLeft + ctx.viewportWidth - width;
      }

      if (actualAboveLeft < ctx.scrollLeft) {
        actualAboveLeft = ctx.scrollLeft;
      }

      if (actualBelowLeft < ctx.scrollLeft) {
        actualBelowLeft = ctx.scrollLeft;
      }

      return {
        fitsAbove: fitsAbove,
        aboveTop: aboveTop,
        aboveLeft: actualAboveLeft,
        fitsBelow: fitsBelow,
        belowTop: belowTop,
        belowLeft: actualBelowLeft
      };
    }
  }, {
    key: "_layoutHorizontalSegmentInPage",
    value: function _layoutHorizontalSegmentInPage(windowSize, domNodePosition, left, width) {
      // Initially, the limits are defined as the dom node limits
      var MIN_LIMIT = Math.max(0, domNodePosition.left - width);
      var MAX_LIMIT = Math.min(domNodePosition.left + domNodePosition.width + width, windowSize.width);
      var absoluteLeft = domNodePosition.left + left - dom.StandardWindow.scrollX;

      if (absoluteLeft + width > MAX_LIMIT) {
        var delta = absoluteLeft - (MAX_LIMIT - width);
        absoluteLeft -= delta;
        left -= delta;
      }

      if (absoluteLeft < MIN_LIMIT) {
        var _delta = absoluteLeft - MIN_LIMIT;

        absoluteLeft -= _delta;
        left -= _delta;
      }

      return [left, absoluteLeft];
    }
  }, {
    key: "_layoutBoxInPage",
    value: function _layoutBoxInPage(topLeft, bottomLeft, width, height, ctx) {
      var aboveTop = topLeft.top - height;
      var belowTop = bottomLeft.top + this._lineHeight;
      var domNodePosition = dom.getDomNodePagePosition(this._viewDomNode.domNode);
      var absoluteAboveTop = domNodePosition.top + aboveTop - dom.StandardWindow.scrollY;
      var absoluteBelowTop = domNodePosition.top + belowTop - dom.StandardWindow.scrollY;
      var windowSize = dom.getClientArea(document.body);

      var _this$_layoutHorizont = this._layoutHorizontalSegmentInPage(windowSize, domNodePosition, topLeft.left - ctx.scrollLeft + this._contentLeft, width),
          _this$_layoutHorizont2 = _slicedToArray(_this$_layoutHorizont, 2),
          aboveLeft = _this$_layoutHorizont2[0],
          absoluteAboveLeft = _this$_layoutHorizont2[1];

      var _this$_layoutHorizont3 = this._layoutHorizontalSegmentInPage(windowSize, domNodePosition, bottomLeft.left - ctx.scrollLeft + this._contentLeft, width),
          _this$_layoutHorizont4 = _slicedToArray(_this$_layoutHorizont3, 2),
          belowLeft = _this$_layoutHorizont4[0],
          absoluteBelowLeft = _this$_layoutHorizont4[1]; // Leave some clearance to the top/bottom


      var TOP_PADDING = 22;
      var BOTTOM_PADDING = 22;
      var fitsAbove = absoluteAboveTop >= TOP_PADDING;
      var fitsBelow = absoluteBelowTop + height <= windowSize.height - BOTTOM_PADDING;

      if (this._fixedOverflowWidgets) {
        return {
          fitsAbove: fitsAbove,
          aboveTop: Math.max(absoluteAboveTop, TOP_PADDING),
          aboveLeft: absoluteAboveLeft,
          fitsBelow: fitsBelow,
          belowTop: absoluteBelowTop,
          belowLeft: absoluteBelowLeft
        };
      }

      return {
        fitsAbove: fitsAbove,
        aboveTop: aboveTop,
        aboveLeft: aboveLeft,
        fitsBelow: fitsBelow,
        belowTop: belowTop,
        belowLeft: belowLeft
      };
    }
  }, {
    key: "_prepareRenderWidgetAtExactPositionOverflowing",
    value: function _prepareRenderWidgetAtExactPositionOverflowing(topLeft) {
      return new Coordinate(topLeft.top, topLeft.left + this._contentLeft);
    }
    /**
     * Compute `this._topLeft`
     */

  }, {
    key: "_getTopAndBottomLeft",
    value: function _getTopAndBottomLeft(ctx) {
      if (!this._viewRange) {
        return [null, null];
      }

      var visibleRangesForRange = ctx.linesVisibleRangesForRange(this._viewRange, false);

      if (!visibleRangesForRange || visibleRangesForRange.length === 0) {
        return [null, null];
      }

      var firstLine = visibleRangesForRange[0];
      var lastLine = visibleRangesForRange[0];

      var _iterator = _createForOfIteratorHelper(visibleRangesForRange),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var visibleRangesForLine = _step.value;

          if (visibleRangesForLine.lineNumber < firstLine.lineNumber) {
            firstLine = visibleRangesForLine;
          }

          if (visibleRangesForLine.lineNumber > lastLine.lineNumber) {
            lastLine = visibleRangesForLine;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var firstLineMinLeft = 1073741824
      /* MAX_SAFE_SMALL_INTEGER */
      ; //firstLine.Constants.MAX_SAFE_SMALL_INTEGER;

      var _iterator2 = _createForOfIteratorHelper(firstLine.ranges),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var visibleRange = _step2.value;

          if (visibleRange.left < firstLineMinLeft) {
            firstLineMinLeft = visibleRange.left;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      var lastLineMinLeft = 1073741824
      /* MAX_SAFE_SMALL_INTEGER */
      ; //lastLine.Constants.MAX_SAFE_SMALL_INTEGER;

      var _iterator3 = _createForOfIteratorHelper(lastLine.ranges),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _visibleRange = _step3.value;

          if (_visibleRange.left < lastLineMinLeft) {
            lastLineMinLeft = _visibleRange.left;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var topForPosition = ctx.getVerticalOffsetForLineNumber(firstLine.lineNumber) - ctx.scrollTop;
      var topLeft = new Coordinate(topForPosition, firstLineMinLeft);
      var topForBottomLine = ctx.getVerticalOffsetForLineNumber(lastLine.lineNumber) - ctx.scrollTop;
      var bottomLeft = new Coordinate(topForBottomLine, lastLineMinLeft);
      return [topLeft, bottomLeft];
    }
  }, {
    key: "_prepareRenderWidget",
    value: function _prepareRenderWidget(ctx) {
      var _this$_getTopAndBotto = this._getTopAndBottomLeft(ctx),
          _this$_getTopAndBotto2 = _slicedToArray(_this$_getTopAndBotto, 2),
          topLeft = _this$_getTopAndBotto2[0],
          bottomLeft = _this$_getTopAndBotto2[1];

      if (!topLeft || !bottomLeft) {
        return null;
      }

      if (this._cachedDomNodeClientWidth === -1 || this._cachedDomNodeClientHeight === -1) {
        var domNode = this.domNode.domNode;
        this._cachedDomNodeClientWidth = domNode.clientWidth;
        this._cachedDomNodeClientHeight = domNode.clientHeight;
      }

      var placement;

      if (this.allowEditorOverflow) {
        placement = this._layoutBoxInPage(topLeft, bottomLeft, this._cachedDomNodeClientWidth, this._cachedDomNodeClientHeight, ctx);
      } else {
        placement = this._layoutBoxInViewport(topLeft, bottomLeft, this._cachedDomNodeClientWidth, this._cachedDomNodeClientHeight, ctx);
      } // Do two passes, first for perfect fit, second picks first option


      if (this._preference) {
        for (var pass = 1; pass <= 2; pass++) {
          var _iterator4 = _createForOfIteratorHelper(this._preference),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var pref = _step4.value;

              // placement
              if (pref === 1
              /* ABOVE */
              ) {
                if (!placement) {
                  // Widget outside of viewport
                  return null;
                }

                if (pass === 2 || placement.fitsAbove) {
                  return new Coordinate(placement.aboveTop, placement.aboveLeft);
                }
              } else if (pref === 2
              /* BELOW */
              ) {
                if (!placement) {
                  // Widget outside of viewport
                  return null;
                }

                if (pass === 2 || placement.fitsBelow) {
                  return new Coordinate(placement.belowTop, placement.belowLeft);
                }
              } else {
                if (this.allowEditorOverflow) {
                  return this._prepareRenderWidgetAtExactPositionOverflowing(topLeft);
                } else {
                  return topLeft;
                }
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      }

      return null;
    }
    /**
     * On this first pass, we ensure that the content widget (if it is in the viewport) has the max width set correctly.
     */

  }, {
    key: "onBeforeRender",
    value: function onBeforeRender(viewportData) {
      if (!this._viewRange || !this._preference) {
        return;
      }

      if (this._viewRange.endLineNumber < viewportData.startLineNumber || this._viewRange.startLineNumber > viewportData.endLineNumber) {
        // Outside of viewport
        return;
      }

      this.domNode.setMaxWidth(this._maxWidth);
    }
  }, {
    key: "prepareRender",
    value: function prepareRender(ctx) {
      this._renderData = this._prepareRenderWidget(ctx);
    }
  }, {
    key: "render",
    value: function render(ctx) {
      if (!this._renderData) {
        // This widget should be invisible
        if (this._isVisible) {
          this.domNode.removeAttribute('monaco-visible-content-widget');
          this._isVisible = false;
          this.domNode.setVisibility('hidden');
        }

        return;
      } // This widget should be visible


      if (this.allowEditorOverflow) {
        this.domNode.setTop(this._renderData.top);
        this.domNode.setLeft(this._renderData.left);
      } else {
        this.domNode.setTop(this._renderData.top + ctx.scrollTop - ctx.bigNumbersDelta);
        this.domNode.setLeft(this._renderData.left);
      }

      if (!this._isVisible) {
        this.domNode.setVisibility('inherit');
        this.domNode.setAttribute('monaco-visible-content-widget', 'true');
        this._isVisible = true;
      }
    }
  }]);

  return Widget;
}();